import React from 'react';

const Variability = () => {
    return (
        <div>Variability Component</div>
    );
}

export default Variability;
